import { render, staticRenderFns } from "./application-create.vue?vue&type=template&id=1c85ed8e&"
import script from "./application-create.vue?vue&type=script&lang=js&"
export * from "./application-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports